import axios from "axios";
import {
    fpoStaffUrl,
    fpoStaffDetailUrl,
    fpoStaffSetPasswordUrl,
} from "../constants/apis";
import { getAuthToken } from "../helpers/local_storage_helpers";

const authHeaders = () => ({
    headers: { Authorization: `Token ${getAuthToken()}` },
});

/**
 * GET /fpo/staff/?page=&page_size=&search=&… — list staff of the caller's FPO
 */
export const getFPOStaff = async (params = {}) => {
    const response = await axios.get(fpoStaffUrl, { ...authHeaders(), params });
    return response;
};

/**
 * POST /fpo/staff/ — add a new staff member (fpo_admin only)
 */
export const addFPOStaff = async (data) => {
    const response = await axios.post(fpoStaffUrl, data, authHeaders());
    return response;
};

/**
 * PATCH /fpo/staff/<id>/ — edit role / designation / is_active (fpo_admin only)
 */
export const updateFPOStaff = async (id, data) => {
    const response = await axios.patch(fpoStaffDetailUrl(id), data, authHeaders());
    return response;
};

/**
 * POST /fpo/staff/<id>/set-password/ — reset a staff member's password (fpo_admin only)
 */
export const setFPOStaffPassword = async (id, newPassword) => {
    const response = await axios.post(
        fpoStaffSetPasswordUrl(id),
        { new_password: newPassword },
        authHeaders()
    );
    return response;
};
